import { Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { debounceTime, fromEvent } from 'rxjs';

import { WINDOW } from '@services/utils/window/window.provider';

@Injectable({
    providedIn: 'root'
})
export class ViewportService {
    private static readonly RESIZE_DEBOUNCE_MS = 100;
    private readonly win = inject(WINDOW);
    private readonly innerWidth = signal(this.win.innerWidth);

    readonly width = this.innerWidth.asReadonly();

    constructor() {
        fromEvent(this.win, 'resize')
            .pipe(debounceTime(ViewportService.RESIZE_DEBOUNCE_MS), takeUntilDestroyed())
            .subscribe(() => this.innerWidth.set(this.win.innerWidth));
    }
}
